import TitledRecordsSelect, { TitledRecordsSelectOptionValueType } from '@/components/TitledRecordsSelect'
import Interview from '@/types/Interview'
import { useEffect, useState } from 'react'
import { marked } from 'marked'

interface Props {
  value: TitledRecordsSelectOptionValueType<Interview>
  options: Interview[]
  className?: string
}

export default function ProjectInterviewsSelect({
  options,
  value,
  className,
}: Props) {
  const [selected, setSelected] = useState<TitledRecordsSelectOptionValueType<Interview>>(value)

  // Order matters: a project resets first, then selectedInterview overrides if present (last setState wins)
  useEffect(() => {
    setSelected(value)
  }, [value])

  return (
    <div className={`d-flex flex-column gap-4 ${className}`}>
      {options.length > 1 &&
        <TitledRecordsSelect<Interview>
          value={selected}
          options={options}
          onChange={interviews => setSelected(interviews)}
          withAll
        />
      }

      {(Array.isArray(selected) ? selected : [selected]).map(it => (
        <div key={it.id} className="d-flex flex-column gap-3 mx-2 mt-4">
          <h3>{it.title}</h3>
          <div dangerouslySetInnerHTML={{ __html: marked(it.transcript) }} />
        </div>
      ))
      }
    </div>
  )
}
